// Components
const TrackDeviceComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "track-device-component" */ '@/app/views/main-view/tracking/components/track-device-component/track-device-component.vue');

// Vue modules
import EventBus from '@/app/bus/event-bus.js';

export default {
	name: 'TrackingContainer',
	mixins: [],
	components: {
		TrackDeviceComponent
	},
	mounted() {
		this.bindWindowResize();
		EventBus.$emit('makeAppFixed', true);
		EventBus.$on('setMapHeight', () => {
			this.setMapHeight();
		});
	},
	beforeDestroy() {
		EventBus.$off('setMapHeight', () => {
			this.setMapHeight();
		});
	},
	methods: {
		setMapHeight() {
			const mapOffset = 110; // header and footer sum height
			$('.vue-map-container').css({'height': `${window.innerHeight - mapOffset}px`})
		},
		bindWindowResize() {
			$(window).on('resize', e => {
				this.setMapHeight();
			});
		},
		unbindWindowResize() {
			$(window).off('resize', e => {
				this.setMapHeight();
			});
			$(window).unbind('scroll');
		}
	},
	beforeRouteEnter(to, from, next) {
		EventBus.$emit('showStickyMenu', true);
		next();
	},
	beforeRouteLeave(to, from, next) {
		this.unbindWindowResize();
		EventBus.$emit('makeAppFixed', false);
		EventBus.$off('makeAppFixed', isAppFixed => {
			this.isAppFixed = isAppFixed;
		});
		next();
	}
}